<template>
    <div>
        <b-alert show>
            <strong>FGTS - Regularidade do Empregador</strong>
        </b-alert>
        <b-row class="pb-2">
            <b-col>
                <p class="mb-0">
                    Data Atualização:
                    <strong>{{
                        fornecedor.fgtsAtualizacao
                            ? $moment(fornecedor.fgtsAtualizacao).format(
                                  'DD/MM/YYYY HH:mm:ss'
                              )
                            : ''
                    }}</strong>
                </p>
                <p class="mb-0">
                    Status:
                    <app-status
                        :status="
                            fornecedor.fgtsSituacao
                                ? fornecedor.fgtsSituacao.toUpperCase()
                                : 'NÃO ATUALIZADO'
                        "
                    ></app-status>
                </p>
                <p class="mb-0">
                    Data Emissão:
                    <strong>{{
                        fornecedor.fgtsDataEmissao
                            ? $moment(fornecedor.fgtsDataEmissao).format(
                                  'DD/MM/YYYY HH:mm:ss'
                              )
                            : ''
                    }}</strong>
                </p>
                <p class="mb-0">
                    Validade:
                    <strong>{{
                        fornecedor.fgtsValidadeInicio
                            ? $moment(fornecedor.fgtsValidadeInicio).format(
                                  'DD/MM/YYYY'
                              )
                            : ''
                    }}</strong>
                    a
                    <strong>{{
                        fornecedor.fgtsValidadeFim
                            ? $moment(fornecedor.fgtsValidadeFim).format(
                                  'DD/MM/YYYY'
                              )
                            : ''
                    }}</strong>
                </p>
                <p>
                    Certificado:
                    <strong>{{ fornecedor.fgtsCertificado }}</strong>
                </p>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        fornecedor: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {},

    computed: {},

    created() {},

    components: {}
}
</script>
